import { memo } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

const workspaceAgentQuoteCard = tailwindVariants({
  base: 'w-full rounded-6 ads:bg-raised bg-gray-2 px-2.5 py-1.5 text-left ads:text-secondary text-12 text-gray-11 leading-4 ads:ring-subtle ring-1 ring-gray-3 ring-inset transition-colors',
  defaultVariants: {
    isInteractive: false,
  },
  variants: {
    isInteractive: {
      true: 'cursor-pointer ads:hover:bg-hover-subtle hover:bg-gray-3 ads:hover:text-primary hover:text-gray-12 ads:hover:ring-default hover:ring-gray-4 focus-visible:outline-none ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-altitude-8',
    },
  },
});

export type WorkspaceAgentQuoteCardProps = {
  attribution?: string;
  'data-testid'?: string;
  onOpen?: () => void;
  quote: string;
};

/**
 * Verbatim text the agent is citing back — a comment, a caption, a note. Rendered as a button only
 * when there is somewhere to go, so a quote with no source stays unfocusable rather than being a
 * dead tab stop.
 */
export const WorkspaceAgentQuoteCard = memo(
  ({ attribution, 'data-testid': testId, onOpen, quote }: WorkspaceAgentQuoteCardProps) => {
    const content = (
      <>
        {quote}
        {attribution ? <span className="mt-0.5 block ads:text-metadata text-gray-10">— {attribution}</span> : null}
      </>
    );

    if (!onOpen) {
      return (
        <p className={workspaceAgentQuoteCard()} data-testid={testId}>
          {content}
        </p>
      );
    }

    return (
      <button
        className={workspaceAgentQuoteCard({ isInteractive: true })}
        data-testid={testId}
        onClick={onOpen}
        type="button"
      >
        {content}
      </button>
    );
  },
);

WorkspaceAgentQuoteCard.displayName = 'WorkspaceAgentQuoteCard';
